'use client';
import React from 'react';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import BrandLogosSection from '@/components/BrandLogosSection';
import BenefitsSection from '@/components/BenefitsSection';
import FeaturesSection from '@/components/FeaturesSection';
import HowItWorksSection from '@/components/HowItWorksSection';
import SellersSection from '@/components/SellersSection';
import JobListingsSection from '@/components/JobListingsSection';
import TestimonialsSection from '@/components/TestimonialsSection';
import PricingSection from '@/components/PricingSection';
import FAQSection from '@/components/FAQSection';
import CTASection from '@/components/CTASection';
import Footer from '@/components/Footer';

export default function Home() {
  return (
    <main className="font-montserrat bg-white text-dark overflow-x-hidden">
      <Navbar />
      <HeroSection />
      <BrandLogosSection />
      <BenefitsSection />
      <FeaturesSection />
      <HowItWorksSection />
      <SellersSection />
      <JobListingsSection />
      <TestimonialsSection />
      <PricingSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </main>
  );
}
